import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";

const lineAnim = keyframes`
to {
    stroke-dashoffset: 0;
}
`;

const StyledAnimatedTitle = styled.div`
  padding: 1rem 0;
  width: 100%;
  position: relative;

  #role {
    width: 80%;
  }
  #role > path {
    stroke: ${(props) => props.theme.fontColor};
  }
  #role > path:nth-of-type(${1}) {
    stroke-dasharray: ${(props) => props.lengthsArray[0]};
    stroke-dashoffset: ${(props) => props.lengthsArray[0]};
    animation: ${lineAnim} 3.7s ease forwards 1s;
  }
  #role > path:nth-of-type(${2}) {
    stroke-dasharray: ${(props) => props.lengthsArray[1]};
    stroke-dashoffset: ${(props) => props.lengthsArray[1]};
    animation: ${lineAnim} 3.7s ease forwards 1.1s;
  }
  #role > path:nth-of-type(${3}) {
    stroke-dasharray: ${(props) => props.lengthsArray[2]};
    stroke-dashoffset: ${(props) => props.lengthsArray[2]};
    animation: ${lineAnim} 3.7s ease forwards 1.2s;
  }
  #role > path:nth-of-type(${4}) {
    stroke-dasharray: ${(props) => props.lengthsArray[3]};
    stroke-dashoffset: ${(props) => props.lengthsArray[3]};
    animation: ${lineAnim} 3.7s ease forwards 1.3s;
  }
  #role > path:nth-of-type(${5}) {
    stroke-dasharray: ${(props) => props.lengthsArray[4]};
    stroke-dashoffset: ${(props) => props.lengthsArray[4]};
    animation: ${lineAnim} 3.7s ease forwards 1.4s;
  }
  #role > path:nth-of-type(${6}) {
    stroke-dasharray: ${(props) => props.lengthsArray[5]};
    stroke-dashoffset: ${(props) => props.lengthsArray[5]};
    animation: ${lineAnim} 3.7s ease forwards 1.5s;
  }
  #role > path:nth-of-type(${7}) {
    stroke-dasharray: ${(props) => props.lengthsArray[6]};
    stroke-dashoffset: ${(props) => props.lengthsArray[6]};
    animation: ${lineAnim} 3.7s ease forwards 1.6s;
  }
  #role > path:nth-of-type(${8}) {
    stroke-dasharray: ${(props) => props.lengthsArray[7]};
    stroke-dashoffset: ${(props) => props.lengthsArray[7]};
    animation: ${lineAnim} 3.7s ease forwards 1.7s;
  }
  #role > path:nth-of-type(${9}) {
    stroke-dasharray: ${(props) => props.lengthsArray[8]};
    stroke-dashoffset: ${(props) => props.lengthsArray[8]};
    animation: ${lineAnim} 3.7s ease forwards 1.8s;
  }
  #role > path:nth-of-type(${10}) {
    stroke-dasharray: ${(props) => props.lengthsArray[9]};
    stroke-dashoffset: ${(props) => props.lengthsArray[9]};
    animation: ${lineAnim} 3.7s ease forwards 1.9s;
  }
  #role > path:nth-of-type(${11}) {
    stroke-dasharray: ${(props) => props.lengthsArray[10]};
    stroke-dashoffset: ${(props) => props.lengthsArray[10]};
    animation: ${lineAnim} 3.7s ease forwards 2s;
  }
  #role > path:nth-of-type(${12}) {
    stroke-dasharray: ${(props) => props.lengthsArray[11]};
    stroke-dashoffset: ${(props) => props.lengthsArray[11]};
    animation: ${lineAnim} 3.7s ease forwards 2.1s;
  }
  #role > path:nth-of-type(${13}) {
    stroke-dasharray: ${(props) => props.lengthsArray[12]};
    stroke-dashoffset: ${(props) => props.lengthsArray[12]};
    animation: ${lineAnim} 3.7s ease forwards 2.2s;
  }
  #role > path:nth-of-type(${14}) {
    stroke-dasharray: ${(props) => props.lengthsArray[13]};
    stroke-dashoffset: ${(props) => props.lengthsArray[13]};
    animation: ${lineAnim} 3.7s ease forwards 2.3s;
  }
  #role > path:nth-of-type(${15}) {
    stroke-dasharray: ${(props) => props.lengthsArray[14]};
    stroke-dashoffset: ${(props) => props.lengthsArray[14]};
    animation: ${lineAnim} 3.7s ease forwards 2.4s;
  }
  #role > path:nth-of-type(${16}) {
    stroke-dasharray: ${(props) => props.lengthsArray[15]};
    stroke-dashoffset: ${(props) => props.lengthsArray[15]};
    animation: ${lineAnim} 3.7s ease forwards 2.5s;
  }
  #role > path:nth-of-type(${17}) {
    stroke-dasharray: ${(props) => props.lengthsArray[16]};
    stroke-dashoffset: ${(props) => props.lengthsArray[16]};
    animation: ${lineAnim} 3.7s ease forwards 2.6s;
  }
`;

export const AnimatedTitle = () => {
  const [lengths, setLengths] = useState([]);
  const roleRef = useRef(null);
  useEffect(() => {
    let tempLength = [];
    var children = roleRef.current.childNodes;
    children.forEach(function (item) {
      if (item.tagName === "path") {
        tempLength.push(item.getTotalLength());
      }
    });
    setLengths(tempLength);
  }, [window.innerWidth]);
  return (
    <StyledAnimatedTitle lengthsArray={lengths} className="desktop">
      <svg
        id="role"
        ref={roleRef}
        width="1041"
        viewBox="0 0 1041 77"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask
          id="path-1-outside-1"
          maskUnits="userSpaceOnUse"
          x="0.15625"
          y="0.8125"
          width="1041"
          height="77"
          fill="black">
          <rect fill="white" x="0.15625" y="0.8125" width="1041" height="77" />
          <path d="M46.1406 45.8125H19.6094V73H3.15625V4.75H48.8125V17.4531H19.6094V33.1562H46.1406V45.8125Z" />
          <path d="M81.0156 48.9062H72.1094V73H55.6562V4.75H82.5156C90.6094 4.75 96.9375 6.54688 101.5 10.1406C106.062 13.7344 108.344 18.8125 108.344 25.375C108.344 30.125 107.375 34.0625 105.438 37.1875C103.531 40.3125 100.531 42.8438 96.4375 44.7812L110.688 72.2969V73H93.0625L81.0156 48.9062ZM72.1094 36.2031H82.5156C85.6406 36.2031 87.9844 35.3906 89.5469 33.7656C91.1406 32.1094 91.9375 29.8125 91.9375 26.875C91.9375 23.9375 91.1406 21.6406 89.5469 19.9844C87.9531 18.2969 85.6094 17.4531 82.5156 17.4531H72.1094V36.2031Z" />
          <path d="M176.078 40.2812C176.078 46.9375 174.844 52.8281 172.375 57.9531C169.906 63.0781 166.391 67.0312 161.828 69.8125C157.297 72.5625 152.125 73.9375 146.312 73.9375C140.5 73.9375 135.344 72.6094 130.844 69.9531C126.344 67.2656 122.828 63.4375 120.297 58.4688C117.797 53.5 116.484 47.7969 116.359 41.3594V37.5156C116.359 30.8281 117.578 24.9375 120.016 19.8438C122.484 14.7188 126 10.7656 130.562 7.98438C135.156 5.20312 140.375 3.8125 146.219 3.8125C152 3.8125 157.156 5.1875 161.688 7.9375C166.219 10.6875 169.734 14.6094 172.234 19.7031C174.766 24.7656 176.047 30.5781 176.078 37.1406V40.2812ZM159.344 37.4219C159.344 30.6406 158.203 25.5 155.922 22C153.672 18.4688 150.438 16.7031 146.219 16.7031C137.969 16.7031 133.609 22.8906 133.141 35.2656L133.094 40.2812C133.094 46.9688 134.203 52.1094 136.422 55.7031C138.641 59.2969 141.938 61.0938 146.312 61.0938C150.469 61.0938 153.672 59.3281 155.922 55.7969C158.172 52.2656 159.312 47.1875 159.344 40.5625V37.4219Z" />
          <path d="M241.562 73H225.203L201.016 30.5312V73H184.562V4.75H201.016L225.156 47.2188V4.75H241.562V73Z" />
          <path d="M304.141 17.4531H283.656V73H267.203V17.4531H247.094V4.75H304.141V17.4531Z" />
          <path d="M353.453 44.0781H327.578V60.3438H358.141V73H311.125V4.75H358.234V17.4531H327.578V31.8438H353.453V44.0781Z" />
          <path d="M421.844 73H405.484L381.297 30.5312V73H364.844V4.75H381.297L405.438 47.2188V4.75H421.844V73Z" />
          <path d="M432.25 73V4.75H454.234C460.266 4.75 465.688 6.125 470.5 8.875C475.312 11.5938 479.062 15.4531 481.75 20.4531C484.469 25.4219 485.844 31 485.875 37.1875V40.3281C485.875 46.5781 484.547 52.1875 481.891 57.1562C479.266 62.0938 475.547 65.9688 470.734 68.7812C465.953 71.5625 460.609 72.9688 454.703 73H432.25ZM448.703 17.4531V60.3438H454.422C459.141 60.3438 462.766 58.6719 465.297 55.3281C467.828 51.9531 469.094 46.9531 469.094 40.3281V37.375C469.094 30.7812 467.828 25.8125 465.297 22.4688C462.766 19.125 459.078 17.4531 454.234 17.4531H448.703Z" />
          <path d="M518.219 73V4.75H540.203C546.234 4.75 551.656 6.125 556.469 8.875C561.281 11.5938 565.031 15.4531 567.719 20.4531C570.438 25.4219 571.812 31 571.844 37.1875V40.3281C571.844 46.5781 570.516 52.1875 567.859 57.1562C565.234 62.0938 561.516 65.9688 556.703 68.7812C551.922 71.5625 546.578 72.9688 540.672 73H518.219ZM534.672 17.4531V60.3438H540.391C545.109 60.3438 548.734 58.6719 551.266 55.3281C553.797 51.9531 555.062 46.9531 555.062 40.3281V37.375C555.062 30.7812 553.797 25.8125 551.266 22.4688C548.734 19.125 545.047 17.4531 540.203 17.4531H534.672Z" />
          <path d="M622.609 44.0781H596.734V60.3438H627.297V73H580.281V4.75H627.391V17.4531H596.734V31.8438H622.609V44.0781Z" />
          <path d="M660.484 54.4375L674.078 4.75H692.453L669.484 73H651.484L628.703 4.75H646.938L660.484 54.4375Z" />
          <path d="M739.797 44.0781H713.922V60.3438H744.484V73H697.469V4.75H744.578V17.4531H713.922V31.8438H739.797V44.0781Z" />
          <path d="M767.641 60.3438H796.281V73H751.188V4.75H767.641V60.3438Z" />
          <path d="M858.016 40.2812C858.016 46.9375 856.781 52.8281 854.312 57.9531C851.844 63.0781 848.328 67.0312 843.766 69.8125C839.234 72.5625 834.062 73.9375 828.25 73.9375C822.438 73.9375 817.281 72.6094 812.781 69.9531C808.281 67.2656 804.766 63.4375 802.234 58.4688C799.734 53.5 798.422 47.7969 798.297 41.3594V37.5156C798.297 30.8281 799.516 24.9375 801.953 19.8438C804.422 14.7188 807.938 10.7656 812.5 7.98438C817.094 5.20312 822.312 3.8125 828.156 3.8125C833.938 3.8125 839.094 5.1875 843.625 7.9375C848.156 10.6875 851.672 14.6094 854.172 19.7031C856.703 24.7656 857.984 30.5781 858.016 37.1406V40.2812ZM841.281 37.4219C841.281 30.6406 840.141 25.5 837.859 22C835.609 18.4688 832.375 16.7031 828.156 16.7031C819.906 16.7031 815.547 22.8906 815.078 35.2656L815.031 40.2812C815.031 46.9688 816.141 52.1094 818.359 55.7031C820.578 59.2969 823.875 61.0938 828.25 61.0938C832.406 61.0938 835.609 59.3281 837.859 55.7969C840.109 52.2656 841.25 47.1875 841.281 40.5625V37.4219Z" />
          <path d="M882.953 49.8438V73H866.5V4.75H893.734C898.953 4.75 903.562 5.71875 907.562 7.65625C911.594 9.5625 914.703 12.2969 916.891 15.8594C919.109 19.3906 920.219 23.4062 920.219 27.9062C920.219 34.5625 917.828 39.8906 913.047 43.8906C908.297 47.8594 901.766 49.8438 893.453 49.8438H882.953ZM882.953 37.1406H893.734C896.922 37.1406 899.344 36.3438 901 34.75C902.688 33.1562 903.531 30.9062 903.531 28C903.531 24.8125 902.672 22.2656 900.953 20.3594C899.234 18.4531 896.891 17.4844 893.922 17.4531H882.953V37.1406Z" />
          <path d="M971.359 44.0781H945.484V60.3438H976.047V73H929.031V4.75H976.141V17.4531H945.484V31.8438H971.359V44.0781Z" />
          <path d="M1008.11 48.9062H999.203V73H982.75V4.75H1009.61C1017.7 4.75 1024.03 6.54688 1028.59 10.1406C1033.16 13.7344 1035.44 18.8125 1035.44 25.375C1035.44 30.125 1034.47 34.0625 1032.53 37.1875C1030.62 40.3125 1027.62 42.8438 1023.53 44.7812L1037.78 72.2969V73H1020.16L1008.11 48.9062ZM999.203 36.2031H1009.61C1012.73 36.2031 1015.08 35.3906 1016.64 33.7656C1018.23 32.1094 1019.03 29.8125 1019.03 26.875C1019.03 23.9375 1018.23 21.6406 1016.64 19.9844C1015.05 18.2969 1012.7 17.4531 1009.61 17.4531H999.203V36.2031Z" />
        </mask>
        <path
          d="M46.1406 45.8125H19.6094V73H3.15625V4.75H48.8125V17.4531H19.6094V33.1562H46.1406V45.8125Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M81.0156 48.9062H72.1094V73H55.6562V4.75H82.5156C90.6094 4.75 96.9375 6.54688 101.5 10.1406C106.062 13.7344 108.344 18.8125 108.344 25.375C108.344 30.125 107.375 34.0625 105.438 37.1875C103.531 40.3125 100.531 42.8438 96.4375 44.7812L110.688 72.2969V73H93.0625L81.0156 48.9062ZM72.1094 36.2031H82.5156C85.6406 36.2031 87.9844 35.3906 89.5469 33.7656C91.1406 32.1094 91.9375 29.8125 91.9375 26.875C91.9375 23.9375 91.1406 21.6406 89.5469 19.9844C87.9531 18.2969 85.6094 17.4531 82.5156 17.4531H72.1094V36.2031Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M176.078 40.2812C176.078 46.9375 174.844 52.8281 172.375 57.9531C169.906 63.0781 166.391 67.0312 161.828 69.8125C157.297 72.5625 152.125 73.9375 146.312 73.9375C140.5 73.9375 135.344 72.6094 130.844 69.9531C126.344 67.2656 122.828 63.4375 120.297 58.4688C117.797 53.5 116.484 47.7969 116.359 41.3594V37.5156C116.359 30.8281 117.578 24.9375 120.016 19.8438C122.484 14.7188 126 10.7656 130.562 7.98438C135.156 5.20312 140.375 3.8125 146.219 3.8125C152 3.8125 157.156 5.1875 161.688 7.9375C166.219 10.6875 169.734 14.6094 172.234 19.7031C174.766 24.7656 176.047 30.5781 176.078 37.1406V40.2812ZM159.344 37.4219C159.344 30.6406 158.203 25.5 155.922 22C153.672 18.4688 150.438 16.7031 146.219 16.7031C137.969 16.7031 133.609 22.8906 133.141 35.2656L133.094 40.2812C133.094 46.9688 134.203 52.1094 136.422 55.7031C138.641 59.2969 141.938 61.0938 146.312 61.0938C150.469 61.0938 153.672 59.3281 155.922 55.7969C158.172 52.2656 159.312 47.1875 159.344 40.5625V37.4219Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M241.562 73H225.203L201.016 30.5312V73H184.562V4.75H201.016L225.156 47.2188V4.75H241.562V73Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M304.141 17.4531H283.656V73H267.203V17.4531H247.094V4.75H304.141V17.4531Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M353.453 44.0781H327.578V60.3438H358.141V73H311.125V4.75H358.234V17.4531H327.578V31.8438H353.453V44.0781Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M421.844 73H405.484L381.297 30.5312V73H364.844V4.75H381.297L405.438 47.2188V4.75H421.844V73Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M432.25 73V4.75H454.234C460.266 4.75 465.688 6.125 470.5 8.875C475.312 11.5938 479.062 15.4531 481.75 20.4531C484.469 25.4219 485.844 31 485.875 37.1875V40.3281C485.875 46.5781 484.547 52.1875 481.891 57.1562C479.266 62.0938 475.547 65.9688 470.734 68.7812C465.953 71.5625 460.609 72.9688 454.703 73H432.25ZM448.703 17.4531V60.3438H454.422C459.141 60.3438 462.766 58.6719 465.297 55.3281C467.828 51.9531 469.094 46.9531 469.094 40.3281V37.375C469.094 30.7812 467.828 25.8125 465.297 22.4688C462.766 19.125 459.078 17.4531 454.234 17.4531H448.703Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M518.219 73V4.75H540.203C546.234 4.75 551.656 6.125 556.469 8.875C561.281 11.5938 565.031 15.4531 567.719 20.4531C570.438 25.4219 571.812 31 571.844 37.1875V40.3281C571.844 46.5781 570.516 52.1875 567.859 57.1562C565.234 62.0938 561.516 65.9688 556.703 68.7812C551.922 71.5625 546.578 72.9688 540.672 73H518.219ZM534.672 17.4531V60.3438H540.391C545.109 60.3438 548.734 58.6719 551.266 55.3281C553.797 51.9531 555.062 46.9531 555.062 40.3281V37.375C555.062 30.7812 553.797 25.8125 551.266 22.4688C548.734 19.125 545.047 17.4531 540.203 17.4531H534.672Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M622.609 44.0781H596.734V60.3438H627.297V73H580.281V4.75H627.391V17.4531H596.734V31.8438H622.609V44.0781Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M660.484 54.4375L674.078 4.75H692.453L669.484 73H651.484L628.703 4.75H646.938L660.484 54.4375Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M739.797 44.0781H713.922V60.3438H744.484V73H697.469V4.75H744.578V17.4531H713.922V31.8438H739.797V44.0781Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M767.641 60.3438H796.281V73H751.188V4.75H767.641V60.3438Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M858.016 40.2812C858.016 46.9375 856.781 52.8281 854.312 57.9531C851.844 63.0781 848.328 67.0312 843.766 69.8125C839.234 72.5625 834.062 73.9375 828.25 73.9375C822.438 73.9375 817.281 72.6094 812.781 69.9531C808.281 67.2656 804.766 63.4375 802.234 58.4688C799.734 53.5 798.422 47.7969 798.297 41.3594V37.5156C798.297 30.8281 799.516 24.9375 801.953 19.8438C804.422 14.7188 807.938 10.7656 812.5 7.98438C817.094 5.20312 822.312 3.8125 828.156 3.8125C833.938 3.8125 839.094 5.1875 843.625 7.9375C848.156 10.6875 851.672 14.6094 854.172 19.7031C856.703 24.7656 857.984 30.5781 858.016 37.1406V40.2812ZM841.281 37.4219C841.281 30.6406 840.141 25.5 837.859 22C835.609 18.4688 832.375 16.7031 828.156 16.7031C819.906 16.7031 815.547 22.8906 815.078 35.2656L815.031 40.2812C815.031 46.9688 816.141 52.1094 818.359 55.7031C820.578 59.2969 823.875 61.0938 828.25 61.0938C832.406 61.0938 835.609 59.3281 837.859 55.7969C840.109 52.2656 841.25 47.1875 841.281 40.5625V37.4219Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M882.953 49.8438V73H866.5V4.75H893.734C898.953 4.75 903.562 5.71875 907.562 7.65625C911.594 9.5625 914.703 12.2969 916.891 15.8594C919.109 19.3906 920.219 23.4062 920.219 27.9062C920.219 34.5625 917.828 39.8906 913.047 43.8906C908.297 47.8594 901.766 49.8438 893.453 49.8438H882.953ZM882.953 37.1406H893.734C896.922 37.1406 899.344 36.3438 901 34.75C902.688 33.1562 903.531 30.9062 903.531 28C903.531 24.8125 902.672 22.2656 900.953 20.3594C899.234 18.4531 896.891 17.4844 893.922 17.4531H882.953V37.1406Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M971.359 44.0781H945.484V60.3438H976.047V73H929.031V4.75H976.141V17.4531H945.484V31.8438H971.359V44.0781Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
        <path
          d="M1008.11 48.9062H999.203V73H982.75V4.75H1009.61C1017.7 4.75 1024.03 6.54688 1028.59 10.1406C1033.16 13.7344 1035.44 18.8125 1035.44 25.375C1035.44 30.125 1034.47 34.0625 1032.53 37.1875C1030.62 40.3125 1027.62 42.8438 1023.53 44.7812L1037.78 72.2969V73H1020.16L1008.11 48.9062ZM999.203 36.2031H1009.61C1012.73 36.2031 1015.08 35.3906 1016.64 33.7656C1018.23 32.1094 1019.03 29.8125 1019.03 26.875C1019.03 23.9375 1018.23 21.6406 1016.64 19.9844C1015.05 18.2969 1012.7 17.4531 1009.61 17.4531H999.203V36.2031Z"
          strokeWidth="6"
          mask="url(#path-1-outside-1)"
        />
      </svg>
    </StyledAnimatedTitle>
  );
};
